import { BaseShareActionArgs, buildShareButtonComponent } from './base'
import { FacebookMessengerIcon } from '../../assets/icons'
import { encodeShareURL, isMobileOrTablet, openPopup } from '../../helpers/sharing_helper'

export const facebookMessengerShareAction = ({
  facebookAppId,
  shareUrl,
  utmParams,
}: BaseShareActionArgs & { facebookAppId: string }) => {
  const mobile = isMobileOrTablet()
  const encodedShareUrl = encodeShareURL(shareUrl, utmParams)
  if (mobile) return window.open(`fb-messenger://share?link=${encodedShareUrl}&app_id=${facebookAppId}`)
  return openPopup(
    `http://www.facebook.com/dialog/send?app_id=${facebookAppId}&link=${encodedShareUrl}&redirect_uri=${encodeURIComponent(shareUrl)}`
  )
}
export const FacebookMessengerButton = buildShareButtonComponent({
  action: facebookMessengerShareAction,
  ariaLabel: 'Facebook Messenger',
  buttonLabel: 'Messenger',
  className: 'share-button--facebook-messenger',
  icon: FacebookMessengerIcon,
})

export type FacebookMessengerButtonProps = Parameters<typeof FacebookMessengerButton>['0']
